'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/shared/event-tracker'
import { ViewLandingPageEvent } from '_libs/common/event-tracker/events'
import { Screen } from 'constants/tracking/screens'
import { ACCESSIBILITY_URL } from 'constants/routes'

import AccessibilityFirstSection from './AccessibilityFirstSection'
import AccesibilitySecondSection from './AccessibilitySecondSection'
import AccessibilityThirdSection from './AccessibilityThirdSection'
import AccessibilityFourthSection from './AccessibilityFourthSection'

const Accessibility = () => {
  const { track } = useTracking()

  useEffect(() => {
    track(
      ViewLandingPageEvent({
        screen: Screen.Accessibility,
        path: ACCESSIBILITY_URL,
        referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
      }),
    )
  }, [track])

  return (
    <div className="accessibility-landingpage">
      <AccessibilityFirstSection />
      <AccesibilitySecondSection />
      <AccessibilityThirdSection />
      <AccessibilityFourthSection />
    </div>
  )
}

export default Accessibility
